import React from 'react'
import styled, { keyframes } from 'styled-components'

const themeProps = {
  default: {
    outerWrapper: {
      width: '120px',
      height: '120px'
    },

    innerWrapper: {
      width: '100px',
      height: '100px'
    },

    stroke: '3px'
  },
  inline: {
    outerWrapper: {
      width: '100%',
      height: '100%'
    },

    innerWrapper: {
      width: '60%',
      height: '60%'
    },

    stroke: '5px'
  }
}

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`
const dash = keyframes`
  0% {
    stroke-dasharray: 1,150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90,150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90,150;
    stroke-dashoffset: -124;
  }
`

const StyledLW = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  min-height: ${props => themeProps[props.theme].outerWrapper.height};
  min-width: ${props => themeProps[props.theme].outerWrapper.width};
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: transparent;
`

const StyledLSW = styled.div`
  width: ${props => themeProps[props.theme].innerWrapper.height};
  height: ${props => themeProps[props.theme].innerWrapper.width};
  margin: 0 auto;
  .spinner-container {
    animation: ${rotate} 2s linear infinite;
  }
  .path {
    stroke-dasharray: 1,150;
    stroke-dashoffset: 0;
    stroke: #66C3E6;
    stroke-linecap: round;
    animation: ${dash} 1.5s ease-in-out infinite;
  }
`

const Loader = ({ theme }) => {
  return (
    <StyledLW theme={theme}>
      <StyledLSW theme={theme}>
        <svg className="spinner-container" viewBox="0 0 52 52">
          <circle
            className="path"
            cx="26px" cy="26px" r="20px" fill="none"
            strokeWidth={themeProps[theme].stroke}
          />
        </svg>
      </StyledLSW>
    </StyledLW>
  )
}

Loader.defaultProps = {
  theme: 'default'
}


export default Loader
